import TermsText from "./TermsText";
import DisclaimerBanner from "./DisclaimerBanner";
import TextContent from "./TextContent";

const AppLowerSection = () => {
  return (
    <div>
      <TermsText />
      <DisclaimerBanner />
      <TextContent />
    </div>
  );
};

export default AppLowerSection;
